import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { MappingService } from 'src/app/services/mapping.service';
import { CurriculumStore } from 'src/app/stores/resources/curriculum.store';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { IProgramLevel } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService } from 'src/app/services/convert.service';

@Component({
  selector: 'app-add-program-level',
  templateUrl: './add-program-level.component.html',
  styleUrls: ['./add-program-level.component.scss']
})
export class AddProgramLevelComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Add New Level"

  form: FormGroup;
  level: AbstractControl;

  LEVEL_LIST: any;
  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  ITEM: IProgramLevel;
  constructor(
    public dialogRef: MatDialogRef<AddProgramLevelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: CurriculumStore,
    private snackBar: MatSnackBar,
    public ds: DataService,
    private resource: ResourceStore,
  ) { }

  async ngOnInit() {
    const LEVEL: IProgramLevel = this.data.LEVEL;
    this.form = this.fb.group({
      level: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      price: [null, Validators.required],
      description: [null],
      order: [null, [Validators.required]],
      hour: [null, [Validators.required]],
    })
    this.level = this.form.controls['level'];

    this.ITEM = LEVEL || null;
    if (LEVEL) {
      this.TITLE = "Edit Level";
      const { description, price, order, hour, key, name } = LEVEL;
      this.form.patchValue({
        level: { key: key, name: name },
        description, price, order, hour,
      })
    }
    const LEVEL_LIST = await this.resource.fetchListArray(COLLECTION_NAME.LEVEL, "name");
    this.LEVEL_LIST = MappingService.autoComplete(this.level, LEVEL_LIST, "name");
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    if (this.form.valid) {
      this.processClose = isDraft ? false : true;
      this.processNew = isDraft;
      this.form.disable();
      const { selectedProgram } = this.store;
      const { selectedCompanyKey, user } = this.auth;
      this.error = null;
      this.isCreate = true;
      const { level, price, description, order, hour } = f;
      const item: IProgramLevel = {
        key: this.ITEM ? this.ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at || this.ds.serverTimestamp() : this.ds.serverTimestamp(),
        created_by: this.ITEM ? this.ITEM.created_by || user.uid : user.uid,
        updated_at: this.ds.serverTimestamp(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key ||  ConvertService.dateKey() : ConvertService.dateKey(),
        page_key: this.ITEM ? this.ITEM.page_key || ConvertService.pageKey() : ConvertService.pageKey(),
        keyword: [ConvertService.toCapitalize(`${level.name}`), ConvertService.toCapitalize(`${selectedProgram.name}`), selectedProgram.key],
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef || this.ds.userProfileRef().doc(user.uid).ref : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: STATUS_OBJECT.submitted,
        //fields
        name: level.name,
        description,
        price,
        programKey: selectedProgram.key,
        programRef: this.ds.programRef().doc(selectedProgram.key).ref,
        levelKey: level.key,
        levelRef: this.ds.levelColRef().doc(level.key).ref,
        order, hour
      }
      this.store.addLevel(item, (success, res) => {
        if (success) {
          this.snackBar.open("Level has been added to program successful.", "Done", { duration: 2500 });
          this.form.reset();
        }
        if (this.ITEM) {
          this.dialogRef.close();
          return;
        }
        this.form.enable();
        this.processNew = false;
        this.processClose = false;
        this.inputEl.nativeElement.focus();
        if (!isNew) {
          this.dialogRef.close();
        }
      })
    }
  }
}